import React from "react";
import { CheckCircle2, XCircle } from "lucide-react";
import { useAlertModal } from "@/hooks/use-alert-modal";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { cn } from "@/lib/utils";

export function AlertModal() {
  const { alert, dismissAlert } = useAlertModal();
  if (!alert) return null;

  const isSuccess = alert.type === "success";
  const isError = alert.type === "error";

  if (isSuccess) {
    return (
      <AlertDialog open={alert.isVisible} onOpenChange={dismissAlert}>
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="rounded-full bg-blue-100 p-3 shadow-lg animate-pop"
            onClick={dismissAlert}
          >
            <CheckCircle2 className="h-16 w-16 text-blue-500" />
          </div>
        </div>
      </AlertDialog>
    );
  }

  // default fallback (error + others)
  return (
    <AlertDialog open={alert.isVisible} onOpenChange={dismissAlert}>
      <AlertDialogContent className="sm:max-w-md">
        <AlertDialogHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
            {isError && (
              <div className="rounded-full bg-red-100 p-3">
                <XCircle className="h-10 w-10 text-red-600" />
              </div>
            )}
          </div>

          {alert.title && (
            <AlertDialogTitle
              className={cn("text-xl font-semibold", isError && "text-red-700")}
            >
              {alert.title}
            </AlertDialogTitle>
          )}

          <AlertDialogDescription className="text-base text-foreground">
            {alert.message}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="sm:justify-center mt-3">
          <AlertDialogAction onClick={dismissAlert}>OK</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
